import React from "react";
import { BaseComponentPlus } from "react-vextensions";
import { YoutubePlayer } from "../General/YoutubePlayer.js";
import { cssHelper } from "react-vextensions";
;
export function ParseYoutubeVideoID(url) {
    var _a;
    return (_a = url === null || url === void 0 ? void 0 : url.match(/v=([A-Za-z0-9_-]{11})/)) === null || _a === void 0 ? void 0 : _a[1];
}
export class YoutubePlayerUI extends BaseComponentPlus({ heightVSWidthPercent: .75, autoplay: false, onPosChanged_callForStartTime: true }) {
    render() {
        const { heightVSWidthPercent, style } = this.props;
        const { css } = cssHelper(this);
        return (React.createElement("div", { ref: c => this.root = c, style: css({ position: "relative", paddingBottom: `${heightVSWidthPercent * 100}%`, height: 0 }, style) }));
    }
    async ComponentDidMount() {
        const { videoID, startTime, autoplay, initPlayer, onPlayerInitialized, onPosChanged, onPosChanged_callForStartTime } = this.props;
        const player = new YoutubePlayer();
        if (initPlayer)
            initPlayer(player);
        this.player = player;
        player.containerUI = this.root;
        await player.EnsureReady();
        if (!this.mounted)
            return;
        if (onPlayerInitialized)
            onPlayerInitialized(player);
        player.LoadVideo({ videoID, startTime }, autoplay);
        /*await player.LoadVideo({videoID, startTime});
        if (autoplay) player.Play();*/
        if (onPosChanged) {
            player.onPositionChanged = onPosChanged;
            if (onPosChanged_callForStartTime && startTime != null) {
                onPosChanged(startTime, "playback"); // it's not really either source, but it's closer to playback
            }
        }
    }
}
//# sourceMappingURL=YoutubePlayerUI.js.map